import { Reducer } from "redux";

import { MaxAllowedSocDateResponse } from "../models/api/Referral";
import { MaxAllowedSocDateDispatchTypes } from "../models/dispatchTypes/Referral";
import { MaxAllowedSocDateActionDispatchTypes } from "../constants/Referral";

export const initialState: MaxAllowedSocDateResponse  = {
  loading: false,
  response: null,
  error: null,
};

const MaxAllowedSocDateReducer: Reducer<
  MaxAllowedSocDateResponse ,
  MaxAllowedSocDateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case MaxAllowedSocDateActionDispatchTypes.GET_MAX_ALLOWED_SOC_DATE_RESET: {
      return initialState;
    }
  }
  return state;
};

export default MaxAllowedSocDateReducer;
